import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import { useGlobalContext } from '../GlobalContextProvider';
import { msalConfig } from '../authConfig';

export default class BaseClient {
  protected _billingDate: Date;
  protected readonly _tenantId: string;
  protected readonly _authToken: string;
  // @ts-ignore
  protected readonly _productId: string = import.meta.env.VITE_PRODUCT_ID;
  protected readonly _swaAuth: 'AzBjl1VJg9b0iOMrdsP4' // Placeholder for Swa auth header


  constructor(billingDate = null, tenantId: string, useAuthentication: boolean = false, pillarCode: string = "") {
    const { getAuthTokenForPillar } = useGlobalContext();
    this._billingDate = billingDate;
    this._authToken = useAuthentication && msalConfig.enabled ? getAuthTokenForPillar(pillarCode) : undefined;
    // @ts-ignore
    this._tenantId = tenantId || import.meta.env.VITE_TENANT_ID;
  }

  protected async get(input, headers = {}) {
    return this.fetch(input, { method: 'GET', headers });
  }

  protected async delete(input) {
    return this.fetch(input, { method: 'DELETE', headers: {} });
  }

  protected async post(input, body, headers = {}) {
    return this.fetch(input, {
      method: 'POST',
      headers: { 'content-type': 'application/json', ...headers },
      body: JSON.stringify(body),
    });
  }

  protected async put(input, body, headers = {}) {
    return this.fetch(input, {
      method: 'PUT',
      headers: { 'content-type': 'application/json', ...headers },
      body: JSON.stringify(body),
    });
  }

  protected async fetch(input, init) {

    const disabledTimeTravelTenantIds = process.env.DISABLED_TIME_TRAVEL_TENANT_IDS.split(',');

    if (disabledTimeTravelTenantIds.includes(this._tenantId)) {
      init.headers = {
        'context-tenantid': this._tenantId,
        "x-stratus-auth": this._authToken,
        "x-stratusswa-auth": this._swaAuth,
        ...init.headers,
      };
      return fetch(input, init);
    }

    
    const contextDateTimeOffset = `${differenceInCalendarDays(this._billingDate, new Date())}:0:00:00`;
    init.headers = {
      'context-datetimeoffset': contextDateTimeOffset,
      'context-tenantid': this._tenantId,
      "x-stratus-auth": this._authToken,
      "x-stratusswa-auth": this._swaAuth,
      ...init.headers,
    };
    
    return fetch(input, init);
  }

  protected async handleResponse<T>(response: Response, returnNullIfNotFound = false): Promise<T> {
    const contentType = response.headers.get('content-type');
    if (response.ok && contentType && contentType.indexOf('application/json') !== -1) {
      const result = await response.text();
      if (result) {
        return JSON.parse(result) as T;
      }
      return null;
    }
    if (response.status === 404) {
      return returnNullIfNotFound ? null : ({} as T);
    }

    const errorResponse = (await response.text()) ?? 'Unknown Exception';
    throw JSON.parse(errorResponse);
  }
}
